import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { AbstractBasicSignalInput } from '../abstract-basic-signal-input.component';
import { FocusDirective } from '@ps-gui/shared-core';

@Component({
  selector: 'shared-ui-text-field',
  imports: [FormsModule, NgClass, NgTemplateOutlet, FocusDirective],
  templateUrl: './text-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextFieldComponent extends AbstractBasicSignalInput<string> {}
